export const LIST_NAME = `planEventType`
export const getBasicUrl = planId => `/plans/${planId}/events/types`
